var copyToClip = (str) => {
  let dummy = document.createElement("div");
  dummy.innerHTML = str;
  copy(dummy.innerHTML);
};
var copy = (str) => {
  function listener(e) {
    e.clipboardData.setData("text/html", str);
    e.clipboardData.setData("text/plain", str);
    e.preventDefault();
  }
  document.addEventListener("copy", listener);
  document.execCommand("copy");
  document.removeEventListener("copy", listener);
};
export default copyToClip;
